import { render, staticRenderFns } from "./destination-advice-modal.vue?vue&type=template&id=665a8dac"
import script from "./destination-advice-modal.vue?vue&type=script&lang=js"
export * from "./destination-advice-modal.vue?vue&type=script&lang=js"
import style0 from "./destination-advice-modal.vue?vue&type=style&index=0&id=665a8dac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports